/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/services/api';
import { User } from '@/types';

//get all users
export const serviceGetAllUsers = async () => {
  try {
    const response = await api.get<User[]>('/users');
    return response.data;
  } catch (error: any) {
    return [] as User[];
  }
};

export const serviceDeleteUser = async (id: number) => {
  try {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
};

export const serviceCreateUser = async (user: {
  name: string;
  email: string;
  password: string;
}) => {
  try {
    const response = await api.post<User>('/users', user);
    return response.data;
  } catch (error: any) {
    const messageError = error?.response?.data?.message || error?.message;
    if (messageError) {
      throw new Error(messageError);
    }
    throw new Error('Erro interno do servidor');
  }
};
